module.exports = __webpack_public_path__ + "img/Icon_comentarios.c76268ce.svg";